//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseNode.js";
import "../no/BasePart.js";
let d=[[],[[["nAspects"],"GetAspects",{R_:{aspects:"AME.AspectNode[]"}},0,0],[[],"GetEngObjectPart",{R_:{part:"Part"}},0,0],[["pageType","nPages","pageObjects"],"GetSymbolPlacements",{R_:{pageFullPageNames:""}},1,0],[["numPorts"],"GetPorts",{R_:{ports:"AME.IPort[]"}},0,0]],[]];
SPLM.AME.AMEPlcHwItem = class extends SPLM.AME.AMEBaseNode{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AMEPlcHwItem";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;